import { makeStyles } from "@material-ui/core";
import { blue, grey, red, green } from "@material-ui/core/colors";

const useStyles = makeStyles((theme) => ({
  noAccessWrapper: {
    borderRadius: "12px",
    padding: theme.spacing(3),
    gap: theme.spacing(3),
    border: `1px solid ${grey[300]}`,
    width: "450px",
    background: "white",
  },
  ffairLogoText: {
    fontSize: "24px",
    fontWeight: 500,
    lineHeight: "25px",
  },
  noLongerValidMessage: {
    fontWeight: 500,
    letterSpacing: "0.15px",
    fontSize: "16px",
    color: red[500],
  },
  validMessage: {
    fontWeight: 500,
    letterSpacing: "0.15px",
    fontSize: "16px",
    color: green[500],
  },
  wrongUserRole: {
    fontWeight: 500,
    letterSpacing: "0.15px",
    fontSize: "16px",
    color: blue.A400,
    textAlign: "center",
  },
  commonText: {
    textAlign: "center",
  },
}));

export default useStyles;
